import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild
} from '@angular/router';
import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { GeneratorsFacadeService } from '../generators-facade/generators-facade.service';

@Injectable({
  providedIn: 'root'
})
export class GeneratorsLoaderGuard implements CanActivate, CanActivateChild {
  constructor(private facade: GeneratorsFacadeService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<true> {
    return this.facade.loaded$.pipe(
      tap(loaded => {
        if (!loaded) {
          this.facade.load();
        }
      }),
      mapTo(true)
    );
  }
  canActivateChild(route: ActivatedRouteSnapshot): Observable<true> {
    return this.canActivate(route);
  }
}
